import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PopOverContainer from '../../../../../components/deprecated/PopOverContainer';
import reactionIcon from '../../../../../icons/reaction.svg';
import EmojiPicker from '../../../../../post/comment/EmojiPicker';
import EditorActions from '../../../../EditorActions';
import usePickReaction from '../../usePickReaction';
import ToolbarButton from '../ToolbarButton';
import selectBlotAndWaitMagneticWallUpdate from './selectBlotAndWaitMagneticWallUpdate';

interface ToolbarReactionButtonProps {
  blot?: unknown;
  onPickerOpenChange?: (open: boolean) => void;
}

const ToolbarReactionButton = ({
  blot,
  onPickerOpenChange,
}: ToolbarReactionButtonProps) => {
  const dispatch = useDispatch();

  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  const handlePick = usePickReaction();

  return (
    <ToolbarButton
      icon={reactionIcon}
      tooltip="Add reaction"
      popOverHideCaret
      // eslint-disable-next-line react/no-unstable-nested-components -- Fix next time editing the file
      popOver={(onClose: () => void) => (
        <PopOverContainer noPadding>
          <EmojiPicker
            onPick={(picked: string) => {
              handlePick(picked);
              onClose();
            }}
          />
        </PopOverContainer>
      )}
      popOverOpen={isEmojiPickerOpen}
      onPopOverOpenChange={async (open: boolean) => {
        setIsEmojiPickerOpen(open);
        onPickerOpenChange?.(open);

        if (open && blot) {
          await selectBlotAndWaitMagneticWallUpdate(blot);
        }
        dispatch(EditorActions.pickingReaction(open));
      }}
    />
  );
};

export default ToolbarReactionButton;
